import * as Sentry from '@sentry/react'

import { isLocalhost, localhostEmbedAddressRegExp, sentryOptions } from 'embed/constants/config'

export const defaultTags = {
  commit: process.env.COMMIT_PREFIX || '',
}

export function initSentry(extraOptions: Partial<Sentry.BrowserOptions> = {}) {
  Sentry.init({
    debug: isLocalhost,
    denyUrls: [localhostEmbedAddressRegExp],
    sampleRate: 0.5,
    ...extraOptions,
  })
}

initSentry(sentryOptions)
